import appConfig from '@/config/appConfig.typed';
import UWM_COMMAND_TYPES from '@/consts/uwm/uwmCommandTypes';
import {LOYALTY_BADGE_CLICK} from '@/consts/uwm/uwmTrackingEventTypes';
import {getMappedInitialLanguageCode} from '@/services/localization/localizationService';
import * as loyaltyUtils from '@/services/loyalty/loyaltyUtils';
import {selectLoyaltyJourneys} from '@/state/selectors/consumerLoyalty';
import {selectDeviceType} from '@/state/selectors/device';
import {getState} from '@/state/store';

const PLATFORM_CODE = 'PWA';

const TIPS_AND_TUTORIALS_VERSION = '6';

const BADGES_DATA_TYPE = 'badges';

const postMessage = (detail) => {
    document.getElementById('uwmIframe')?.contentWindow?.postMessage({detail}, '*');
};

const postTipsAndTutorialsInitMessage = ({isQuickStartGuide, isCleaningGuide, deviceType, skipFirstStep}) => {
    postMessage({
        command: UWM_COMMAND_TYPES.UWM_INIT_TIPS_TUTORIALS,
        payload: {
            deviceType: deviceType || selectDeviceType(getState()),
            materialColor: null,
            isQuickStartGuide,
            isCleaningGuide,
            skipFirstStep,
            platformCode: PLATFORM_CODE,
            version: TIPS_AND_TUTORIALS_VERSION,
        },
    });
};

const postLoyaltyInitMessage = () => {
    const loyaltyJourneys = selectLoyaltyJourneys(getState());

    postMessage({
        command: UWM_COMMAND_TYPES.UWM_INIT_LOYALTY,
        payload: {
            badgesConfiguration: loyaltyJourneys,
            platformCode: PLATFORM_CODE,
        },
    });
};

const postLoyaltyRefreshMessage = () => {
    postMessage({
        command: UWM_COMMAND_TYPES.UWM_REFRESH_DATA,
        payload: {
            dataType: BADGES_DATA_TYPE,
            badgesConfiguration: selectLoyaltyJourneys(getState()),
        },
    });
};

const postMarketLocaleInitMessage = () => {
    const countryCode = appConfig.getIccMarketName();
    const languageCode = getMappedInitialLanguageCode()?.toUpperCase();

    postMessage({
        command: UWM_COMMAND_TYPES.UWM_INIT_MARKET_LOCALE,
        payload: {
            countryCode,
            languageCode,
        },
    });
};

const trackGaEvent = (eventType, params) => {
    switch (eventType) {
        case LOYALTY_BADGE_CLICK:
            const {badgeId} = params;

            loyaltyUtils.trackLoyaltyClick(badgeId);
            break;
        default:
            break;
    }
};

export default {
    postMessage,
    postTipsAndTutorialsInitMessage,
    postLoyaltyInitMessage,
    postLoyaltyRefreshMessage,
    postMarketLocaleInitMessage,
    trackGaEvent,
};
